// src/components/shell/MobileTopBar.js
// Barre du haut mobile : burger + titre de la page + thème + avatar.
// Elle s'efface quand on descend et revient dès qu'on remonte (façon app native).
//
// Overlay fixe : le contenu réserve sa hauteur via le padding-top de <main>
// (--fm-topbar-h). L'état masqué est piloté par le shell (Layout), qui passe
// --fm-topbar-h à 0 en même temps — sinon la place réservée resterait vide sur
// les pages dont c'est un conteneur interne qui défile (et non <main>).
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SHELL_LABELS, titleForPath } from "./navConfig";
import useMe from "../../hooks/useMe";
import { PageNavButton } from "./PageNav";
import AccountSheet from "./AccountSheet";
import UserAvatar from "./UserAvatar";
import { LanguageFlagSwitcher } from "./LanguageSwitcher";

export default function MobileTopBar({ onOpenMenu, hidden = false }) {
  const { pathname } = useLocation();
  const { user, initials } = useMe();
  const [accountOpen, setAccountOpen] = useState(false);
  const { i18n } = useTranslation();
  const lang = (i18n.language || "fr").startsWith("en") ? "en" : "fr";
  const t = SHELL_LABELS[lang];
  const title = titleForPath(pathname, t);

  return (
    <>
    <header
      data-hidden={hidden ? "true" : "false"}
      className="fm-topbar lg:hidden fixed inset-x-0 top-0 z-30 border-b border-slate-200 bg-white/90 backdrop-blur-md dark:border-white/10 dark:bg-[#0b0d15]/90"
    >
      <div className="flex h-14 items-center gap-1 px-1.5">
        <button
          onClick={onOpenMenu}
          className="fm-tap grid h-11 w-11 shrink-0 place-items-center rounded-xl text-slate-600 dark:text-slate-200"
          aria-label="Menu"
        >
          <Menu size={22} />
        </button>

        <h1 className="min-w-0 flex-1 truncate text-[17px] font-semibold tracking-tight text-slate-900 dark:text-white">
          {title}
        </h1>

        {/* Langue exposée en clair (drapeau), comme sur desktop. */}
        <LanguageFlagSwitcher size={36} className="shrink-0" />

        <button
          onClick={() => setAccountOpen(true)}
          className="fm-tap grid h-11 w-11 shrink-0 place-items-center rounded-xl"
          aria-label={t.account}
        >
          <UserAvatar photo={user?.photo} initials={initials} size={32} className="text-xs" />
        </button>

        {/* Tout à droite : sous-menu de la page, s'il y en a un. */}
        <PageNavButton />
      </div>
    </header>

    {/* Bottom sheet compte — HORS du header (son backdrop-blur casserait le
        positionnement fixed du sheet, le collant sous la barre). */}
    <AccountSheet open={accountOpen} onClose={() => setAccountOpen(false)} />
    </>
  );
}
